<template>
  <section id="outro" class="outro">
    <BackgroundImage
      name="img_outro_background"
      :class="['outro-background', 'content-padder']"
    >
      <h4 class="outro-background-headline">
        <i18n path="outro_headline">
          <Copyright />
        </i18n>
      </h4>
      <p class="outro-background-subheadline">
        {{ $i18n.t("outro_subheadline") }}
      </p>
      <div class="outro-background-overlay"></div>
      <div class="outro-background-overlaycontent">
        <p>
          <i18n path="outro_overlay_headline">
            <Copyright />
          </i18n>
        </p>
        <a
          href="https://vio.erbe-med.com/"
          :title="$i18n.t('outro_overlay_link_title')"
          >{{ $i18n.t("outro_overlay_link_text") }}</a
        >
      </div>
    </BackgroundImage>
  </section>
</template>

<script>
import BackgroundImage from "@/components/BackgroundImage";
import Copyright from "@/components/Symbols/Copyright";
export default {
  components: {
    BackgroundImage,
    Copyright,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss";
.outro {
  &-background {
    height: 1700px;
    text-align: center;
    position: relative;
    padding-top: 40px;
    @include breakpoint(xs) {
      height: 580px;
    }
    @include breakpoint(s) {
      height: 820px;
    }
    &-headline {
      color: $text_dark;
      @include ts-section-headline();
    }
    &-subheadline {
      color: $text_dark;
      @include ts-section-subheadline();
      margin-top: 10px;

      @include breakpoint(xs) {
        margin-top: 0;
      }
    }
    &-overlay,
    &-overlaycontent {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 340px;
      @include breakpoint(xs) {
        height: 90px;
      }
      @include breakpoint(s) {
        height: 178px;
      }
    }
    &-overlay {
      background-color: rgba(177, 222, 210, 1);
      mix-blend-mode: multiply;
      @include ie_or_edge() {
        background-color: rgba(177, 222, 210, 0.6);
      }
    }
    &-overlaycontent {
      @include flex-v(center, center);
      p {
        text-align: center;
        font-family: $font_nettoBlack;
        font-size: 50px;
        line-height: 60px;
        letter-spacing: 3px;
        color: #ffffff;
        @include breakpoint(xs) {
          font-size: 16px;
          line-height: 30px;
          letter-spacing: 0.96px;
        }
        @include breakpoint(s) {
          font-size: 24px;
          line-height: 30px;
          letter-spacing: 1.44px;
        }
      }
      a {
        text-align: center;
        font-family: $font_nettoBlack;
        font-size: 50px;
        line-height: 60px;
        letter-spacing: 3px;
        color: #00aeef;
        margin-top: 20px;
        @include breakpoint(xs) {
          font-size: 16px;
          line-height: 30px;
          letter-spacing: 0.96px;
          margin-top: 0px;
        }
        @include breakpoint(s) {
          font-size: 24px;
          line-height: 30px;
          letter-spacing: 1.44px;
        }
      }
    }
  }
}
</style>
